<template>
    <div id="data-list-list-view" class="data-list-container">
        <edit-service
                :isSidebarActive="showSidebar"
                :data="sidebarData"
                @closeSidebar="toggleSidebar"
                :loadService="listService"
        />
        <vs-table
                ref="table"
                v-model="selected"
                :max-items="itemsPerPage"
                search
                :data="services"
        >
            <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
                <div class="flex flex-wrap-reverse items-center data-list-btn-container">
                    <div class="btn-add-new p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-center text-lg font-medium text-base text-primary border border-solid border-primary"
                    >
                        <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
                        <span class="ml-2 text-base text-primary" @click="addNewService">Nouveau Service</span>
                    </div>
                </div>
            </div>

            <template slot="thead">
                <vs-th sort-key="name">Service</vs-th>
                <vs-th sort-key="created_at">Créé le</vs-th>
                <vs-th>Action</vs-th>
            </template>

            <template slot-scope="{ data }">
                <tbody>
                <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                    <vs-td width="50%">{{ tr.name }}</vs-td>
                    <vs-td width="30%">{{ tr.created_at }}</vs-td>
                    <vs-td class="whitespace-no-wrap" width="20%">
                        <div class="flex">
                            <vx-tooltip text="Modifier">
                                <feather-icon
                                        icon="EditIcon"
                                        svgClasses="w-5 h-5 hover:text-primary stroke-current"
                                        class="mr-2"
                                        @click="edit(tr)"
                                />
                            </vx-tooltip>
                            <vx-tooltip text="Supprimer">
                                <feather-icon @click="deleteService(tr)"
                                        icon="TrashIcon"
                                        svgClasses="w-5 h-5 hover:text-primary stroke-current"
                                        class="mr-2"
                                />
                            </vx-tooltip>
                        </div>
                    </vs-td>
                </vs-tr>
                </tbody>
            </template>
        </vs-table>
        <vs-pagination v-if="last_page && page" :total="last_page" v-model="page"></vs-pagination>
    </div>
</template>

<script>
    import EditService from "./EditService";
    export default {
        components: {EditService},
        data() {
            return {
                itemsPerPage: 8,
                isMounted: false,
                selected: [],
                sidebarData: {},
                showSidebar: false,
                last_page: 1,
                page: 1,
                services: []
            }
        },
        computed: {

        },
        mounted() {
            this.isMounted = true;
            this.listService()
        },
        methods: {
            toggleSidebar(val = false) {
                this.showSidebar = val;
            },
            addNewService(){
                this.sidebarData = {};
                this.toggleSidebar(true);
            },
            edit(data){
                this.sidebarData = data;
                this.toggleSidebar(true);
            },
            listService() {
              this.$vs.loading()
              this.$http.get('/services').then((response) => {
                this.services = response.data.data
                this.last_page = response.data.last_page
                this.$vs.loading.close()
              }).catch((error) => {
                this.$vs.loading.close()
                if (error.response.status === 401) {
                  this.$router.push('/login')
                }
              })
            },
            deleteService(el){
                if (confirm('Voulez vous supprimer ce service ?')){
                  this.$vs.loading()
                  this.$http.post('/services/delete', {id: el.id}).then((response) => {
                    if (response.data.status){
                      this.$vs.loading.close()
                      let index = this.services.indexOf(el)
                      this.services.splice(index, 1)
                      window.GETCCMT.notification('success','Success','Opération effectuée');
                    }else window.GETCCMT.notification('error','Echec','Une erreur est survenu');
                  }).catch((error) => {
                    this.$vs.loading.close()
                    if (error.response.status === 401) {
                      this.$router.push('/login')
                    }else window.GETCCMT.notification('error','Echec','Une erreur est survenu');
                  })
                }
            }
        }
    }
</script>

<style lang="scss">
    #data-list-list-view {
        .vs-con-table {
            @media (max-width: 689px) {
                .vs-table--search {
                    margin-left: 0;
                    max-width: unset;
                    width: 100%;

                    .vs-table--search-input {
                        width: 100%;
                    }
                }
            }

            @media (max-width: 461px) {
                .items-per-page-handler {
                    display: none;
                }
            }

            @media (max-width: 341px) {
                .data-list-btn-container {
                    width: 100%;

                    .dd-actions,
                    .btn-add-new {
                        width: 100%;
                        margin-right: 0 !important;
                    }
                }
            }

            .product-name {
                max-width: 23rem;
            }

            .vs-table--header {
                display: flex;
                flex-wrap: wrap;
                margin-left: 1.5rem;
                margin-right: 1.5rem;
                > span {
                    display: flex;
                    flex-grow: 1;
                }

                .vs-table--search {
                    padding-top: 0;

                    .vs-table--search-input {
                        padding: 0.9rem 2.5rem;
                        font-size: 1rem;

                        & + i {
                            left: 1rem;
                        }

                        &:focus + i {
                            left: 1rem;
                        }
                    }
                }
            }

            .vs-table {
                border-collapse: separate;
                border-spacing: 0 0.5rem;
                padding: 0 1rem;

                tr {
                    box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
                    td {
                        padding: 20px;
                        &:first-child {
                            border-top-left-radius: 0.5rem;
                            border-bottom-left-radius: 0.5rem;
                        }
                        &:last-child {
                            border-top-right-radius: 0.5rem;
                            border-bottom-right-radius: 0.5rem;
                        }
                    }
                    td.td-check {
                        padding: 20px !important;
                    }
                }
            }

            .vs-table--thead {
                th {
                    padding-top: 0;
                    padding-bottom: 0;

                    .vs-table-text {
                        text-transform: uppercase;
                        font-weight: 600;
                    }
                }
                th.td-check {
                    padding: 0 15px !important;
                }
                tr {
                    background: none;
                    box-shadow: none;
                }
            }

            .vs-table--pagination {
                justify-content: center;
            }
        }
    }
</style>
